import React, { useMemo } from 'react';
import { WrappedFieldProps } from 'redux-form';
import { FormItemProps } from 'antd/lib/form';
import { TextAreaProps } from 'antd/lib/input';
import { Form, Input } from 'antd';

export const TextAreaField = React.memo<
  WrappedFieldProps & { item: FormItemProps; field: TextAreaProps }
>(({ input, item, field, meta: { touched, error, warning } }) => {
  const errorText = useMemo(() => touched && error, [touched, error]);
  const warningText = useMemo(() => touched && warning, [touched, warning]);
  const validateStatus = useMemo(() => {
    if (errorText) {
      return 'error';
    } else if (warningText) {
      return 'warning';
    }
  }, [errorText, warningText]);

  return (
    <Form.Item
      validateStatus={validateStatus}
      help={errorText || warningText}
      {...item}
    >
      <Input.TextArea {...input} {...field} />
    </Form.Item>
  );
});
